import Actions                 from 'Redux/Actions';
import { OrganizerRepository } from 'Domain/Repositories';
import { ofType }              from 'redux-observable';
import { from }                from 'rxjs';
import { mergeMap }            from 'rxjs/operators';
import { TEpic }               from 'Redux/Config';

export const removeEmployeeFromOrganisationEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.removeEmployeeFromOrganisationRequest.type),
    mergeMap(action => from(
      OrganizerRepository.removeEmployeeFromOrganisation(action.payload)
        .then(() => Actions.removeEmployeeFromOrganisationSuccess({ organisationId: action.payload.organisationId }))
        .catch((error: Error) => Actions.removeEmployeeFromOrganisationFailure({ error })),
    )),
  );
};
